import {
    useRef
} from 'react';

import { SimpleGrid, Text } from '@mantine/core';
import { Link, useParams } from 'react-router-dom';

import { useOrders } from '../hooks/useOrders.ts';
import { useOrdersSelection } from '../hooks/useOrdersSelection.ts';

import {
    MantineDataTable,
    TableSearchForm,
} from '@flexinet/ui-components';
import { DataTableColumn } from "mantine-datatable";
import { DataTableTokenPagination } from "../../../components/DataTableTokenPagination.tsx";
import { Order } from '../types';

export const RecordsTable = () => {
    const {selectedRecords, setSelectedRecords} = useOrdersSelection();

    const {
        items,
        totalCount,
        loading,
        nextToken,
        fetchRecords,
        handleFilterByKeyword
    } = useOrders();



    const scrollViewportRef = useRef<HTMLDivElement>(null);

    const columns: DataTableColumn<Order>[] = [
        {
            accessor: 'id',
            title: 'Order ID',
            render: (record: Order) => {
                const { id: customerId } = useParams();
                return (
                    <Link to={`/customers/${customerId}/orders/${record.id}`} style={{ textDecoration: 'none' }}>
                        <Text c="blue" style={{ cursor: 'pointer' }}>
                            {record.id.substring(0, 8)}...
                        </Text>
                    </Link>
                );
            }
        },
        {
            accessor: 'customerId',
            title: 'Customer ID',
            render: (record: Order) => (
                <Text size="sm">
                    {record.customerId.substring(0, 8)}...
                </Text>
            )
        },
        {
            accessor: 'subscriptionId',
            title: 'Subscription ID',
            render: (record: Order) => (
                <Text size="sm">
                    {record.subscriptionId.substring(0, 8)}...
                </Text>
            )
        },
        {
            accessor: 'created',
            title: 'Created',
            render: (record: Order) => (
                <Text size="sm">
                    {record.created ? new Date(record.created).toLocaleDateString() : '-'}
                </Text>
            )
        },
        {
            accessor: 'createdByUsername',
            title: 'Created By',
            render: (record: Order) => (
                <Text size="sm">
                    {record.createdByUsername || '-'}
                </Text>
            )
        },
    ];

    return (
        <SimpleGrid verticalSpacing='xl' m='sm'>
            <TableSearchForm handleFilterByKeyword={handleFilterByKeyword} />

            <MantineDataTable
                columns={columns}
                records={items}
                selectedRecords={selectedRecords}
                onSelectedRecordsChange={setSelectedRecords}
                fetching={loading}
                onScrollToBottom={() => fetchRecords()}
                scrollViewportRef={scrollViewportRef}
                withTableBorder={true}
            />

            <DataTableTokenPagination totalCount={totalCount.toString()} nextToken={nextToken} handleLoadMore={fetchRecords} />

        </SimpleGrid>
    );
};